/* Motion layer: staggered reveals, count-up figures. Content stays readable without it. */
(function () {
  'use strict';
  var doc = document.documentElement;
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  doc.classList.add('sp-motion');

  /* Section heads, prose and CTA blocks join the reveal set. Blocks that already hold reveal items are skipped. */
  document.querySelectorAll('.sp-section:not(.sp-hero) .sp-container > *').forEach(function (el) {
    if (el.classList.contains('sp-reveal') || el.querySelector('.sp-reveal') || el.matches('nav, script, style')) return;
    el.classList.add('sp-reveal');
  });
  document.querySelectorAll('.sp-post, .sp-study, .sp-faq details').forEach(function (el) { el.classList.add('sp-reveal'); });

  /* Stagger siblings */
  var groups = new Map();
  document.querySelectorAll('.sp-reveal').forEach(function (el) {
    var p = el.parentElement;
    var i = groups.get(p) || 0;
    el.style.setProperty('--sp-d', (i % 6) * 90 + 'ms');
    groups.set(p, i + 1);
  });

  function markIn(el, now) {
    el.classList.add('is-in');
    var d = now ? 0 : (parseFloat(el.style.getPropertyValue('--sp-d')) || 0) + 1050;
    setTimeout(function () { el.classList.add('is-done'); }, d);
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { io.unobserve(en.target); markIn(en.target, false); }
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
  document.querySelectorAll('.sp-reveal').forEach(function (el) {
    if (el.classList.contains('is-in') || el.getBoundingClientRect().top < window.innerHeight * 0.92) { markIn(el, true); } else { io.observe(el); }
  });

  /* Count-up for key figures: €496K, 4.16x, 2,947, $245K, 5,000+ ... */
  function countUp(el) {
    var final = el.textContent.trim();
    var m = final.match(/^([^\d]*)(\d[\d,]*(?:\.\d+)?)(.*)$/);
    if (!m) return;
    var raw = m[2], grouped = raw.indexOf(',') > -1;
    var target = parseFloat(raw.replace(/,/g, ''));
    var decimals = (raw.split('.')[1] || '').length;
    if (!isFinite(target) || target === 0) return;
    var t0 = null, dur = 1600;
    function fmt(v) {
      var s = v.toFixed(decimals);
      if (grouped) { var parts = s.split('.'); parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ','); s = parts.join('.'); }
      return m[1] + s + m[3];
    }
    function step(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      var e = 1 - Math.pow(2, -10 * p);
      el.textContent = p < 1 ? fmt(target * e) : final;
      if (p < 1) requestAnimationFrame(step);
    }
    el.style.minWidth = el.offsetWidth + 'px';
    requestAnimationFrame(step);
  }
  var nio = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { nio.unobserve(en.target); countUp(en.target); }
    });
  }, { threshold: 0.5 });
  document.querySelectorAll('.sp-stats__value, .sp-hero__stat-value, .sp-stat__value, .sp-fnote__facts b').forEach(function (el) { nio.observe(el); });
})();
